import type { PartnerDto } from "../../../../api";
import { Heading } from "../../../../components/common/typography";
import { Badge } from "../../../../components/common/badge";

interface PartnerHeaderProps {
  partner: PartnerDto;
}

export function PartnerHeader({ partner }: PartnerHeaderProps) {
  const isBuyer = (partner.customerRank ?? 0) > 0;
  const isSeller = (partner.supplierRank ?? 0) > 0;
  const partnerType =
    isBuyer && isSeller
      ? "Buyer & Seller"
      : isBuyer
      ? "Buyer"
      : isSeller
      ? "Seller"
      : "Partner";

  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div className="flex flex-col gap-2">
        <Heading variant="h2" tone="dark">
          {partner.name || "Unnamed Partner"}
        </Heading>
        <div className="flex flex-wrap items-center gap-2">
          <Badge
            label={partner.active ? "Active" : "Inactive"}
            state={partner.active ? "success" : "error"}
          />
          {(isBuyer || isSeller) && (
            <Badge label={partnerType} state="pending" />
          )}
          {partner.companyType && (
            <Badge label={partner.companyType} state="pending" />
          )}
        </div>
      </div>
    </div>
  );
}
